"use client";

import PrivacyPolicyContentTh from "./PrivacyPolicyContent.th";
import PrivacyPolicyContentEn from "./PrivacyPolicyContent.en";

export default function PrivacyPolicyContent({ lang = "th" }: { lang?: "th" | "en" }) {
  if (lang === "en") return <PrivacyPolicyContentEn />;
  return <PrivacyPolicyContentTh />;
}
